export const getGreeting = () => {
    let newDate = new Date();
    let hours = newDate.getHours();
    if (hours < 12) {
      return "Buenos días";
    } else if (hours >= 12 && hours < 18) {
      return "Buenas tardes";
    } else {
      return "Buenas noches";
    }
}